<template>
  <div>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="pressNews"
        :search="search"
        :items-per-page="15"
        :custom-filter="filterItems"
        :footer-props="{
          itemsPerPageOptions: [15, 30, -1],
          itemsPerPageText: $t('table.itemsPerPageText')
        }"
        sort-by="date"
        sort-desc
        class="table-cursor"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
            />
            <v-menu offset-y class="mr-2">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="search == '' ? 'grey' : 'orange'"
                  :outlined="search != ''"
                  :text="search == ''"
                  v-bind="attrs"
                  v-on="on"
                  class="mx-0 mx-lg-2"
                  icon
                >
                  <v-icon
                   v-if="search == ''"
                  >
                    mdi-filter-outline
                  </v-icon>
                  <v-icon
                   v-else
                  >
                    mdi-filter-check
                  </v-icon>
                </v-btn>
              </template>
              <v-list>
                <!-- media_type:@ -->
                <v-list-item @click.stop>
                  <v-menu offset-x>
                    <template v-slot:activator="{ on, attrs }">
                      <v-list-item-title
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon
                          :color="search.includes('media_type:') ? 'orange' : 'grey'"
                        >
                          mdi-multimedia
                        </v-icon>
                        Tipo de medio
                        <v-icon class="grey--text text--lighten-1 float-right">mdi-menu-down</v-icon>
                      </v-list-item-title>
                    </template>
                    <v-list>
                      <v-for
                        :key="type"
                        v-for="type in ['radio', 'newspapers', 'web', 'tv', 'agency']"
                        :value="type"
                      >
                        <v-list-item
                          link
                          @click="filterSearchAdd('media_type:@', type)"
                        >
                          <v-list-item-title>
                            <v-icon
                              v-if="search.includes(`media_type:${type}`)"
                            >
                              mdi-check-circle
                            </v-icon>
                            <v-icon
                              v-else
                            >
                              mdi-circle-small
                            </v-icon>
                            {{ $t(`pressNew.media_types.${type}`) }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-for>
                    </v-list>
                  </v-menu>
                </v-list-item>

                <!-- scope:@ -->
                <v-list-item @click.stop>
                  <v-menu offset-x>
                    <template v-slot:activator="{ on, attrs }">
                      <v-list-item-title
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon
                          :color="search.includes('scope:') ? 'orange' : 'grey'"
                        >
                          mdi-account-multiple
                        </v-icon>
                        Ámbito
                        <v-icon class="grey--text text--lighten-1 float-right">mdi-menu-down</v-icon>
                      </v-list-item-title>
                    </template>
                    <v-list>
                      <v-for
                        :key="type"
                        v-for="type in ['national', 'international']"
                        :value="type"
                      >
                        <v-list-item
                          link
                          @click="filterSearchAdd('scope:@', type)"
                        >
                          <v-list-item-title>
                            <v-icon
                              v-if="search.includes(`scope:${type}`)"
                            >
                              mdi-check-circle
                            </v-icon>
                            <v-icon
                              v-else
                            >
                              mdi-circle-small
                            </v-icon>
                            {{ $t(`pressNew.scope_types.${type}`) }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-for>
                    </v-list>
                  </v-menu>
                </v-list-item>

                <!-- featured -->
                <v-list-item
                  link
                  @click="filterSearchAdd('featured','')"
                >
                  <v-list-item-title>
                    <v-icon
                      :color="search.includes('featured') ? 'orange' : 'grey'"
                    >
                      mdi-alert-octagram
                    </v-icon>
                    Destacadas
                  </v-list-item-title>
                </v-list-item>

                <v-divider></v-divider>
                
                <v-list-item
                  link
                  @click="filterSearchClear()"
                >
                  <v-list-item-title>
                    <v-icon>
                      mdi-delete
                    </v-icon>
                    Borrar filtros
                  </v-list-item-title>
                </v-list-item>
                  
              </v-list>
            </v-menu>
            <v-spacer />
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                  to="/manage/edit/pressNews/add"
                  ><v-icon class="mr-2">mdi-plus-thick</v-icon
                  >{{ $t("button.newItem") }}</v-btn
                >
              </template>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.scope="{ item }">
          {{ $t(`pressNew.scope_types.${item.scope}`) }}
        </template>
        <template v-slot:item.media_type="{ item }">
          {{ $t(`pressNew.media_types.${item.media_type}`) }}
        </template>
        <template
              v-slot:item.features="{ item }"
            >
              <v-tooltip
                v-if="item.featured === true"
                top
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="green"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-alert-octagram
                  </v-icon>
                </template>
                {{ $t('table.features.isFeatured') }}
              </v-tooltip>
              <v-icon
                v-else
                color="grey"
                v-bind="attrs"
                v-on="on"
              >
                mdi-alert-octagram-outline
              </v-icon>
            </template>
        <template v-slot:item.actions="{ item }">
          <v-btn class="mr-2" color="primary" :to="`/manage/edit/pressNews/edit/${item.id}`" text icon>
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-icon color="red" @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
      <v-row>
        <v-col class="text-right">
          <VueJsonToCsv :json-data="enrichedPressNews" csv-title="stays">
            <v-btn text color="secondary" class="mr-2" :disabled="enrichedPressNews.length < 1">
              <v-icon left>mdi-file-table-box</v-icon>
              <span class="d-none d-md-block">{{ $t('table.exportCSV') }}</span>
              <span class="d-block d-md-none">{{ $t('table.exportCSV_short') }}</span>
            </v-btn>
          </VueJsonToCsv>
        </v-col>
        <v-col>
          <VueJsonToExcel :data="enrichedPressNews" name="stays.xls">
            <v-btn text color="secondary" :disabled="enrichedPressNews.length < 1">
              <v-icon left>mdi-microsoft-excel</v-icon>
              <span class="d-none d-md-block">{{ $t('table.exportExcel') }}</span>
              <span class="d-block d-md-none">{{ $t('table.exportExcel_short') }}</span>
            </v-btn>
          </VueJsonToExcel>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import VueJsonToCsv from "vue-json-to-csv";
import VueJsonToExcel from "vue-json-excel";
import pressNew_model from "@/mixins/model_utils/pressNew_model";
import filterSearchMixin from '../../mixins/filterSearchMixin.js'
export default {
  mixins: [pressNew_model, filterSearchMixin],
  components: {VueJsonToCsv, VueJsonToExcel},
  data() {
    return {
      dialog: false,
      search: "",
      pressNews: [],
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("title.title"),
          value: "title",
        },
        {
          text: this.$t("table.media_type"),
          value: "media_type",
          width: "15%"
        },
        {
          text: this.$t("table.media"),
          value: "media"
        },
        {
          text: this.$t("table.scope"),
          value: "scope",
          width: "12%"
        },
        {
          text: this.$t("table.date"),
          value: "date"
        },
        {
          text: this.$t("form.features"),
          value: "features",
          filterable: false,
          width: "15%",
          sortable: false
        },
        {
          text: this.$t("actions"),
          value: "actions",
          width: "10%",
          align: "end",
          filterable: false,
          sortable: false
        }
      ];
    },
    enrichedPressNews() {
      return this.pressNews.map(item => {
        return {
          title: item.title,
          uri: item.uri,
          media_type: this.$t(`pressNew.media_types.${item.media_type}`),
          media: item.media,
          scope: this.$t(`pressNew.scope_types.${item.scope}`),
          date: item.date,
          featured: item.featured ? this.$t('table.features.isFeatured') : this.$t('table.features.notFeatured'),
          year: item.date.substring(0, 4)
        };
      });
    }
  },
  created() {
    this.getMediaTypes();
    this.getScopeTypes();
    this.initialize();
  },

  methods: {
    initialize() {
      let path = this.$store.state.endpoint + "/news";
      axios
        .get(path)
        .then(response => {
          this.pressNews = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    deleteItem(item) {
      if (confirm(this.$t('message.confirm.delete'))) {
        let path = this.$store.state.endpoint + "/news/" + item.id;
        axios
          .delete(path)
          .then(response => {
            const index = this.pressNews.indexOf(item);
            this.pressNews.splice(index, 1);
            this.$store.commit("alert", {
              color: "success",
              text: this.$t('message.correct.deleteItem')
            });
          })
          .catch(error => {
            console.log(error);
            this.$store.commit("alert", {
              color: "error",
              text: error.response
            });
          });
      }
    },
    filterItems(value, search, item) {
      const search_array = search
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .split(",")
        .map(x => x.trim());
      const customValue = (
        item.title +
        " " +
        item.date +
        " " +
        (item.featured !== false ? " featured" : "") +
        " " +
        "media_type:" + item.media_type +
        " " +
        "media:" + item.media + 
        " " +
        "year:" + item.date.substring(0,4) + 
        " " +
        "scope:" + item.scope
        )
        .toString()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      return (
        customValue != null &&
        search_array != null &&
        typeof customValue === "string" &&
        search_array.every(function(search){ return customValue.indexOf(search) !== -1 })
      );
    },
  }
};
</script>
